module.exports = __webpack_public_path__ + "img/cooperation.4ddb9ec1.png";